import requestv2 from "~/utils/http-v2";

const authApi = {
	login : async (username, password) => {
		const url = 'auth/login';
		return await requestv2.post(url, {username, password});
	},
	refresh : async (params) => {
		const url = 'auth/refresh-token';
		return await requestv2.post(url, params);
	},
	current : async () => {
		const url = 'auth/current';
		return await requestv2.get(url);
	},
	avatar : async (params) => {
		const url = `auth/avatar`;
		return await requestv2.post(url, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	password : async (params) => {
		const url = `auth/password`;
		return await requestv2.put(url, params);
	}
};

export default authApi;